import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import jobGroupActions from 'actions/jobGroups'
import jobReasonActions from 'actions/jobReasons'
import assetCategoryActions from 'actions/assetCategories'
import assetActions from 'actions/assets'
import operatorGroupActions from 'actions/operatorGroups'
import operatorActions from 'actions/operators'
import Component from 'components/Reports/JobProgressReport/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  jobGroups: selectors.jobGroups.selectOptions(state),
  jobReasons: selectors.jobReasons.selectOptions(state),
  assetCategories: selectors.assetCategories.selectOptions(state),
  assets: selectors.assets.selectOptions(state, { itemsOnly: false }),
  operatorGroups: selectors.operatorGroups.selectOptions(state),
  operators: selectors.operators.selectOptions(state, { itemsOnly: false }),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ ...params, active: 'All', locationVendingTypes: ['NonVending'] })),
  getJobGroups: (params) => dispatch(jobGroupActions.getOptions(params)),
  getJobReasons: (params) => dispatch(jobReasonActions.getOptions(params)),
  getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
  getAssets: (params) =>
    dispatch(
      assetActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
  getOperatorGroups: (params) => dispatch(operatorGroupActions.getOptions(params)),
  getOperators: (params) =>
    dispatch(
      operatorActions.getOptions({
        active: 'All',
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
